var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.classes,on:{"click":_vm.handleClick}},[_c('img',{attrs:{"src":`/images/sections/about-us/history/${_vm.type}_${
      _vm.active ? 'active' : 'inactive'
    }.svg`}}),_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }